import { Label, Tab } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutCommentsAndReferenceNumbers } from "./autogen/AutogenLayoutCommentsAndReferenceNumbers";


export class CommentsAndReferenceNumbers extends AutogenLayoutCommentsAndReferenceNumbers {
    private _ediStopId: string;
    private _stopRow: ModelRow<any>;
    private _refnoCount: number;
    private _commentCount: number;

    override onLoad() {
        this.styleTab(this.tabStopComments);
        this.styleTab(this.tabStopRefNumbers);
    }
    get ediStopId(): string {
        return this._ediStopId;
    }
    set ediStopId(value: string) {
        this._ediStopId = value;
        this.sourceEdiRefNumber.search({ stop_id: this._ediStopId });
        this.sourceEdiStopNote.search({ stop_id: this._ediStopId });
    }

    styleTab(tab: Tab) {
        if (tab.heading != null && tab.headingLabel != null) {
            tab.heading.color = "subtle.light";
            tab.headingLabel.setProps({ color: "default", fontBold: true, fillRow: false })
            if (tab["countLabel"] == null) {
                tab["countLabel"] = new Label({
                    fontBold: true, text: "0", fillRow: true,
                    color: "primary", rowBreak: false, marginLeft: 5
                });
                tab.heading.insert(tab["countLabel"], 1);
            }
        }
    }

    sourceEdiRefNumberAfterExecution() {
        this._refnoCount = this.sourceEdiRefNumber.data.length;
        if (this.tabStopRefNumbers != null && this.tabStopRefNumbers["countLabel"] != null) {
            this.tabStopRefNumbers["countLabel"].text = this._refnoCount;
        }
    }

    sourceEdiStopNoteAfterExecution() {
        this._commentCount = this.sourceEdiStopNote.data.length;
        if (this.tabStopComments != null && this.tabStopComments["countLabel"] != null) {
            this.tabStopComments["countLabel"].text = this._commentCount;
        }
    }

    get parentStopExpandedComponent() {
        return this.parent as CommentsAndReferenceNumbers;
    }
}
